import initialState from "../state.js";
function rootReducer(state = initialState, action) {
  switch (action.type) {
    case "TOKEN":
      return { ...state, token: action.data };
    case "INFO":
      return { ...state, info: action.data };
    case "ARRAY_TESTS":
      return { ...state, arrayTests: action.data };
    case "STATUSES":
      return { ...state, statuses: action.data };
    case "USER":
      return { ...state, user: action.data };
    case "USERS":
      return { ...state, users: action.data };
    default:
      return state;
  }
}

export default rootReducer;
